// src/components/ui/PortfolioCard.js
import { Link } from 'react-router-dom';
import { useLang } from '../../i18n/LanguageContext';
import CandleSVG from '../candles/CandleSVG';
import styles from './PortfolioCard.module.css';

export default function PortfolioCard({ item }) {
  const { t, ui } = useLang();

  return (
    <Link to={`/portfolio/${item.slug}`} className={styles.card} style={{ '--color': item.color }}>
      <div className={styles.img}>
        {item.image
          ? <img src={item.image} alt={t(item, 'title')} className={styles.photo} />
          : (
            <div className={styles.svgWrap}>
              <CandleSVG shape={item.candle_shape} color={item.color} size={110} />
            </div>
          )
        }
        {item.category && (
          <span className={styles.tag} style={{ background: item.category.color }}>
            {t(item.category, 'name')}
          </span>
        )}
        {item.is_featured && (
          <span className={styles.featured}>{ui('ویژه', 'Featured')}</span>
        )}
      </div>
      <div className={styles.body}>
        <h3 className={styles.title}>{t(item, 'title')}</h3>
        <p className={styles.desc}>{t(item, 'description')}</p>
        <span className={styles.more}>{ui('مشاهده جزئیات ←', 'View Details →')}</span>
      </div>
    </Link>
  );
}
